import { render, staticRenderFns } from "./WhatYouGet.vue?vue&type=template&id=781563d7&scoped=true&"
import script from "./WhatYouGet.vue?vue&type=script&lang=js&"
export * from "./WhatYouGet.vue?vue&type=script&lang=js&"
import style0 from "./WhatYouGet.vue?vue&type=style&index=0&id=781563d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781563d7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/app/components/base/Btn.vue').default})
